module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/separated_bathroom-73c1ab34a4cc3500fb74ab776d3a7a61.svg";